import React from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import "./FloatingButtons.css";

const FloatingButtons = () => {
  return (
    <div className="floating-buttons">
      <a
        href="https://wa.me/40726104358"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn whatsapp"
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
      </a>

      <a
        href="tel:+40726104358"
        className="floating-btn phone"
        aria-label="Sună acum"
      >
        <FaPhoneAlt />
      </a>
    </div>
  );
};

export default FloatingButtons;